import { render, staticRenderFns } from "./AddressEditor.vue?vue&type=template&id=8428ffb4&scoped=true&"
import script from "./AddressEditor.vue?vue&type=script&lang=js&"
export * from "./AddressEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8428ffb4",
  null
  
)

export default component.exports